<!-- 更多 -->
<template>
  <div id="more">
    <div class="main">
      <div>
        <!-- 头部地理位置和搜索框 -->
        <div class="head">
          <!-- 顶部NavBar 开始 -->
          <van-nav-bar
            :title="$t('moreMpplications.title')"
            :left-text="$t('main.return')"
            left-arrow
            style="background-color: rgba(255,255,255,0);"
            @click-left="onClickLeft"
          />
        </div>
      </div>
      <div class="outboxstyle">
        <div style="font-size:16px;background:#fff;border-radius:16px 16px 0px 0px;padding:20px">
          <van-form>
            <van-row>
              <van-col :span="24">
                <div>
                  <van-field
                    v-model="listQuery.projectName"
                    name=""
                    right-icon="search"
                    label=""
                    :placeholder="$t('moreMpplications.input')"
                    class="picker"
                    @input="searchChange"
                  />
                </div>
              </van-col>
            </van-row>
          </van-form>
          <van-collapse v-model="activeNames">
            <van-collapse-item v-for="(item ,itemIndex) in proTypeList" :key="itemIndex" class="" :name="item.itemIndex">
              <template #title>
                <div class="title-class">{{ item.name }}</div>
              </template>
              <!-- {{ item.children }} -->
              <div class="flex">
                <div
                  v-for="son in item.children"
                  v-show="(son.proModelUrl === 'tuitionAndDorm' ||son.proModelUrl === 'common' || son.proModelUrl === 'meeting' || son.isParentProject === 'YES')&& son.searchShow === true"
                  :key="son.name"
                  class="imgBox"
                  @click="goToPay(son,item,itemIndex)"
                >
                  <img :src="son.imgUrl" alt="" class="img img-size">
                  <p class="text wrapText">{{ son.name }}</p>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <!-- 回到顶部按钮 -->
      <v-top />
    </div>
    <ReiTabbar />
  </div>
</template>
<script>
import { getProjectIsAllowPayment } from '@/api/project'
import { Toast } from 'vant'
import { getProjectTypeAndProjectInfoListInit, getProjectTypeAndProjectInfoList } from '@/api/projectType'
// import { getStuNotice } from '@/api/notice'
import ReiTabbar from '../components/ReiTabbar.vue'
export default {
  name: 'MoreMpplications',
  components: {
    ReiTabbar
  },
  data() {
    return {
      imgTemp: [
        { imgUrl: require('../../assets/newImages/icon8.png') }
      ],
      collapseList: [
      ],
      proTypeList: [],
      activeNames: [],
      listQuery: {
        projectName: ''
      }
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background: #F5F5F5')
  },
  mounted() {
    this.init()
  },
  methods: {
    // 检索方法
    searchChange() {
      // 获取数据时$set了展示标记
      if (this.listQuery.projectName !== '') {
        // 先关闭大组
        this.activeNames = []
        // 初始全部隐藏
        for (let i = 0; i < this.proTypeList.length; i++) {
          for (let j = 0; j < this.proTypeList[i].children.length; j++) {
            this.$set(this.proTypeList[i].children[j], 'searchShow', false)
          }
        }
        // 子组检索
        const sonList = []
        const showFather = []
        for (let i = 0; i < this.proTypeList.length; i++) {
          for (let j = 0; j < this.proTypeList[i].children.length; j++) {
            const isHave = this.proTypeList[i].children[j].name.indexOf(this.listQuery.projectName)
            // console.log('大组', i, '小组', j, 'isHave索引:', isHave)
            if (isHave !== -1) {
              showFather.push({
                first: i,
                second: j
              })
              this.$set(this.proTypeList[i].children[j], 'searchShow', true)
              // console.log('isHave', i, j, isHave)
              // i属于第几大组
              sonList.push(i)
            }
          }
        }
        // 去重  展开哪些大组
        const showList = Array.from(new Set(sonList))
        this.activeNames = showList
      } else {
        this.activeNames = []
        // ""时全部可见  延迟  要不会闪
        setTimeout(() => {
          for (let i = 0; i < this.proTypeList.length; i++) {
            for (let j = 0; j < this.proTypeList[i].children.length; j++) {
              this.$set(this.proTypeList[i].children[j], 'searchShow', true)
            }
          }
        }, 1000)
      }
    },
    // 跳转项目缴费页面
    goToPay(son, item, itemIndex) {
      // console.log('item', item)
      // console.log('itemIndex', itemIndex)

      if (son.isParentProject === 'YES') {
        // 是父项目
        getProjectTypeAndProjectInfoList(son.id).then(res => {
          // console.log('父res', res)
          const data = res.data
          for (let i = 0; i < res.data.length; i++) {
            this.$set(data[i], 'searchShow', true)
          }
          // console.log(data, 'data')

          this.$set(this.proTypeList[itemIndex], 'children', data)
        })
      } else {
        // 子项目  直接跳转
        getProjectIsAllowPayment(son.id).then(response => {
          this.messageCode = response.messageCode
          if (this.messageCode !== '0') {
            Toast.fail({
              message: response.data,
              type: 'error'
            })
            return false
          } else {
          // 根据不同Mode要进不同页面走不同接口
            this.$router.push({ path: son.proModelUrl + 'Pay', query: { projectId: son.id }})
          }
        })
      }
    },
    init() {
      // 获取 首页获取项目类型列表 携带一级项目
      getProjectTypeAndProjectInfoListInit(this.$store.state.settings.schoolCode).then(response => {
        // console.log('getProjectTypeAndProjectInfoListInit')
        this.proTypeList = response.data
        // console.log('proTypeList', this.proTypeList)
        for (let i = 0; i < this.proTypeList.length; i++) {
          if (this.proTypeList[i].children) {
            for (let j = 0; j < this.proTypeList[i].children.length; j++) {
              // 设置检索标记 searchShow
              this.$set(this.proTypeList[i].children[j], 'searchShow', true)
            }
          }
        }
        // console.log('proTypeList2', this.proTypeList)
      })
    },
    // 返回
    onClickLeft() {
      this.$router.push({ path: '/home' })
    },
    // 带参数跳转页面
    dealwith(item) {
      this.$router.push({
        path: '/login'
      })
    }
  }
}
</script>
<style scoped lang="scss">
.wrapText{
  line-height: 30px;
  width:80%;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:1;
  color: #2E2E2E;
  height:14px;
  font-size:14px;
}
.imgBox{
  width: 25%;
  padding: 4px;
  img{
    margin: 7px auto;
    width: 46px;
    height: 46px;
  }
  .text{
    text-align: center;
    // width:60px;
    margin: 0 auto;
    height:12px;
    font-size:12px;
    font-family:STHeitiSC-Light,STHeitiSC;
    font-weight:300;
    color:rgba(46,46,46,1);
    line-height:12px;
  }
}
.title-class{
    color: #2F9FF2;
}
.border{
    border:1px solid #D0D0D0;
}
.collapse{
    border-bottom: 1px solid #D0D0D0;
}
#more {
  .van-cell {
  line-height: 30px;
  padding:0;
  }
  .van-icon__image {
    width: 40px;
    height: 30px;
}
  position: relative;
  background-color: #eff6ff;
  .head {
    height: 84px;
    width: 100%;
    background:linear-gradient(135deg, #3793e5 0%, #4046a6 100%);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.outboxstyle {
  // padding: 0px 10px 10px 10px;
  background-color: #F5F5F5;
  border-radius: 10px;
  margin-top: -20px;
  margin-bottom: 100px;
  width: 100%;
  height: 100%;
}
.boxstyle {
  margin: 10px 15px 0 15px;
  background-color: #ffffff;
  border: 1px white solid;
  border-radius: 10px;
  box-shadow: 0px 4px 10px #dde9f3;
  p{
    font-size:16px;
    font-weight:700;
    margin: 20px;
  }
}
.buttontext{
  width:90px;
  border-radius:5px
}
.bottom{
  width: 100%;
  background: #ffffff;
  height: 80px;
  margin-top:20px;
}
.bottombutton{
  margin: 20px;
  width:90%;
  height: 40px;
}
.van-cell__value {
  span{
    color: #333333;
  }
}
#totalpay {
  .van-cell__value {
  span{
    color: #3BA4F2;
  }
}
}
</style>
<style>
.van-nav-bar .van-icon {
    color: #ffffff;
}
.van-nav-bar__title {
    color: #ffffff;
}
.van-nav-bar__text {
    color: #ffffff;
}
[class*='van-hairline']::after {
    border: none;
}
.van-nav-bar {
  height: 80px;
}
</style>
<style lang="scss" scoped>
.main{
  margin-bottom:50px;
}
.box{
  width: 86%;
  margin:0 auto;
  padding:0 10%;
  height:120px;
  background:linear-gradient(135deg,rgba(55,147,229,1) 0%,rgba(61,105,199,1) 100%);
  border-radius:12px;
}
.img-box{
width:60px;
height:60px;
border:1px solid #ffffff;
background:#fff;
border-radius:50% ;
margin-top:26px;
}
.text-box{
margin-top:20px;

  p {
    font-size:14px;
    line-height: 30px;
    height: 20px;
    color: rgba(216,235,244,1);
    span{
    color: #FFFFFF;
    }
  }
}
.picker{
  border: 1px solid #eee;
  border-radius: 10px;
  margin: 5px 10px;
  width: 95%;
  padding: 5px 10px !important;
}
</style>
